export const DIFFICULTY_LABELS = {
  beginner: 'Athlete',
  intermediate: 'Champion',
  advanced: 'Warrior'
};

export const getDifficultyLabel = (difficulty) =>
  DIFFICULTY_LABELS[difficulty] || (difficulty ? difficulty.charAt(0).toUpperCase() + difficulty.slice(1) : difficulty);

const API = process.env.REACT_APP_BACKEND_URL;

/** Resolve a media URL — handles S3 URLs, local /api paths, and external URLs */
export const resolveMediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API}${url}`;
};

/** Get the best thumbnail URL for a workout */
export const getWorkoutThumbnail = (workout) => {
  if (workout.video_thumbnail) return resolveMediaUrl(workout.video_thumbnail);
  return workout.image_url || '';
};
